import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.label_review_runtime_v5');
import { OnInit, Input } from '@angular/core';

@Component({ standalone: false,
    selector: 'wiz-page-xray-label_review_runtime_v5',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.label_review_runtime_v5/view.scss */
/* src/app/page.xray.label_review_runtime_v5/view.scss: no such file or directory */`],
})
export class PageXrayLabel_review_runtime_v5Component implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageXrayLabel_review_runtime_v5Component;